import { createAction } from "@ngrx/store";
import { Quicklink } from "@obg/ngx.core.content/public-api";
import { Observable } from "rxjs";

import { SBPopularCategoriesResponse } from "./sb-popular-categories.model";

export namespace SBPopularCategoriesAction {
	const ACTION_PREFIX = "[SB Popular Categories]";

	export const fetchAll = createAction(`${ACTION_PREFIX} Fetch All`, (quickLinks$: Observable<Quicklink[]>) => ({
		quickLinks$,
	}));

	export const fetchAllSuccess = createAction(
		`${ACTION_PREFIX} Fetch All Success`,
		(categories: SBPopularCategoriesResponse, quickLinks$: Observable<Quicklink[]>) => ({ categories, quickLinks$ })
	);

	export const fetchAllFail = createAction(`${ACTION_PREFIX} Fetch All Failed`, (error) => ({ error }));

	export const transformToQuickLinksSuccess = createAction(
		`${ACTION_PREFIX} Transform Quick Links Success`,
		(quickLinksCategories: Quicklink[]) => ({ quickLinksCategories })
	);
}
